(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-product-recommendations"] && !Shopify.designMode) return;
  try {
    
  const initStoreProductRecommendations = () => {
    const sections = document.querySelectorAll('.store-product-recommendations:not([data-recommendations-loaded])');

    sections.forEach((sectionEl) => {
      const url = sectionEl.dataset.url;
      if (!url || url.includes('product_id=&') || url.endsWith('product_id=')) {
        sectionEl.setAttribute('data-recommendations-loaded', 'true');
        return;
      }

      const loadRecommendations = () => {
        if (sectionEl.dataset.recommendationsLoaded === 'true') return;
        sectionEl.setAttribute('data-recommendations-loaded', 'true');

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const incoming = html.querySelector('.store-product-recommendations');
            if (incoming && incoming.innerHTML.trim().length) {
              sectionEl.innerHTML = incoming.innerHTML;
            }
          })
          .catch((error) => {
            console.error(error);
          });
      };

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0]?.isIntersecting) return;
          observer.unobserve(sectionEl);
          loadRecommendations();
        },
        { rootMargin: '0px 0px 200px 0px' }
      );

      observer.observe(sectionEl);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStoreProductRecommendations);
  } else {
    initStoreProductRecommendations();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.store-product-recommendations')) {
      initStoreProductRecommendations();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
